import { type TermsDocumentClass } from '@bms2/shared';
import { SETTINGS_PATH } from './api';

/**
 * The Terms Sets routes and the shapes the Sets tab reads (piece 15; decisions 1170 and 1172), apart from the tab
 * so that a company's Terms set window, on the record page, reads them without the Terms pages (T3600; decision 10641).
 */

/** 🔨 Relative to the API's own root: the routes of decisions 1170 and 1172. */
export const TERMS_SETS_PATH = `${SETTINGS_PATH}/terms/sets`;
export function termsSetPath(id: string): string {
  return `${TERMS_SETS_PATH}/${encodeURIComponent(id)}`;
}
export function termsSetRetirePath(id: string): string {
  return `${termsSetPath(id)}/retire`;
}
export function termsClassPath(documentClass: string): string {
  return `${SETTINGS_PATH}/terms/classes/${encodeURIComponent(documentClass)}`;
}
export function termsClientPath(companyId: string): string {
  return `${SETTINGS_PATH}/terms/clients/${encodeURIComponent(companyId)}`;
}

/** One set as the server lists it. */
export interface TermsSetView {
  id: string;
  name: string;
  termSectionIds: string[];
  defaultForClasses: string[];
  confidentialityRoleId: string | null;
  confidentialityRoleName: string | null;
  clientCount: number;
}

/** The Sets tab's answer, typed against what `GET settings/terms/sets` sends. */
export interface TermsSetsAnswer {
  sets: TermsSetView[];
  classes: { documentClass: TermsDocumentClass; label: string; kinds: string[]; setId: string | null }[];
  roles: { id: string; name: string }[];
}
